class AppDialog {
    constructor() {
        document.addEventListener(
            "alpine:init",
            () => {
                Alpine.data("appDialog", () => ({
                    config: null,

                    init() {
                        window.alpineRender(this);
                        setTimeout(() => {
                            if (
                                !this.storage()?.get("app_dialog") &&
                                !document.querySelector("#qc-cmp2-main")
                            ) {
                                document
                                    .querySelector(`[x-ref='dialogApp']`)
                                    ?.showModal();
                            }
                        }, 1000);
                    },
                    isProduction() {
                        return this.config?.env === "production";
                    },
                    // Production: cookie (may be unavailable on page load, retry until usable). Otherwise: localStorage
                    storage() {
                        if (!this.isProduction()) {
                            return window.useLocalStorage;
                        }
                        if (
                            window.useCookieStorage &&
                            window.useCookieStorage.type !== "cookieStorage"
                        ) {
                            window.useCookieStorage =
                                new window.useCookieStorage.constructor();
                        }
                        return window.useCookieStorage;
                    },
                    closeAppDialog() {
                        this.storage()?.set(
                            "app_dialog",
                            true,
                            this.isProduction()
                                ? { maxAge: 3600 * 24 * 31 }
                                : undefined,
                        );
                    },
                }));
            },
            { once: true },
        );
    }
}

new AppDialog();
